// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    // Fermeture de la carte au scroll
    window.addEventListener('scroll', function() {
        var slideshowCarte = document.querySelector('.home-slideshow__carte');
        if (window.scrollY > 1) {
            slideshowCarte.classList.add('hidden');
        } else {
            slideshowCarte.classList.remove('hidden');
            // Vérifie si l'élément est actuellement survolé avant de retirer la classe 'hovered'
            if (!slideshowCarte.classList.contains('hovered')) {
                slideshowCarte.classList.remove('hovered');
            }
        }
    });

    // Utiliser les événements 'mouseenter' et 'mouseleave' au lieu de 'mouseover' et 'mouseout'
    var slideshowCarte = document.querySelector('.home-slideshow__carte');
    slideshowCarte.addEventListener('mouseenter', function() {
        if (window.scrollY > 0) {
            slideshowCarte.classList.add('hovered');
        }
    });

    slideshowCarte.addEventListener('mouseleave', function() {
        slideshowCarte.classList.remove('hovered');
    });
}